import React, { Component } from "react";
import Loader from "../../components/Loader";
import { withTranslation } from "react-i18next";
import {
    Box,
    TextField,
    Select,
    MenuItem,
    Button,
    Grid,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Paper, InputLabel, InputAdornment, FormControl
} from "@mui/material";
import { useState, useEffect, useCallback, useRef } from "react";
import { GetDashboardLogListSearchUrl, GetDashboardLogListExcelUrl, GetThirdPartyAPI, SearchUserAndADGroupUrl, logoutUrl, dashboardGroupActionID } from "../../utils/constants";
import { useToast } from '../../components/toast';
import { Search, List, GridView, StarOutline, Star, Share, Delete, Edit, Close, Save, Cancel } from "@mui/icons-material";
import {  axiosPost } from "../../utils/Axios";
import CommonPagination from "../../components/CommonPagination";
import { useTranslation } from 'react-i18next';
import moment from "moment";
import dayjs from 'dayjs';
import _, { set } from 'lodash';
import { useNavigate } from "react-router-dom";
import { useFillList } from "../../components/fillList";
import { HeaderBlock } from "@colliers/colliers-b2c";
import axios from 'axios';

const DashboardLog = (_props) => {
    const navigate = useNavigate()
    const { ToastComponent, showToast } = useToast();
    const [isLoading, setIsLoading] = useState(false);
    const [userName, setUserName] = useState("");
    const [dashboard, setDashboard] = useState("");
    const [DashboardGroupID, setDashboardGroupID] = useState("");
    const [DashboardGroupFillList, setDashboardGroupFillList] = useState([]);
    const groupFillList = useFillList(dashboardGroupActionID, "", ""); // Action ID 3

    const [dashboardLogList, setdashboardLogList] = useState([]);
    const [reset, setReset] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const listItemsPerPage = 10;
    const [filteredDashboardLog, setFilteredDashboardLog] = useState(dashboardLogList);
    const startIndex = (currentPage - 1) * listItemsPerPage;
    const paginatedDashboardLog = filteredDashboardLog?.slice(startIndex, startIndex + listItemsPerPage);
    const totalItems = filteredDashboardLog?.length;

    const { t } = useTranslation();

    const handleDashboardChange = (event) => {
        setDashboard(event.target.value);
    };
    const searchBtnCall = async () => {
        getDashboardLogList();
        setReset(false)
    }
    const resetSearch = async () => {
        setFromDate("");
        setToDate("");
        setDateRange("");
        setShowDatePickers(false);
        setUserName("");
        setDashboard("");
        setDashboardGroupID("");
        setReset(true)
    };
   

    const isEmpty = (value) => {
        return value == null || value === "";
    };
    const getDateRange = (dateRange, fromDate, toDate) => {
        if (isEmpty(dateRange)) return "";
        return dateRange.includes("Between") ? `${fromDate}|${toDate}` : dateRange;
    };
    const getDashboardGroupID = (dashboardGroupID) => {
        return dashboardGroupID && dashboardGroupID !== 'select' ? dashboardGroupID : null;
    };

    const exportBtnCall = async () => {
        setIsLoading(true);
        try {
            const dashboardLogSearchParam = {
                dateRange: getDateRange(dateRange, fromDateRef.current, toDateRef.current),
                dashboard: isEmpty(dashboard) ? "" : dashboard,
                name: isEmpty(userName) ? "" : userName,
                dashboardGroupID: getDashboardGroupID(DashboardGroupID),
            };
            const response = await axios.post(GetDashboardLogListExcelUrl, dashboardLogSearchParam, { responseType: 'blob' }
            );
            if (response) {
                const blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                }); let fileName = "DashboardLogExcel.xlsx";
                const disposition = response.headers['content-disposition'];
                if (disposition) {
                    const filenameStarMatch = disposition.match(/filename\*\=UTF-8''(.+?)(?:;|$)/);
                    if (filenameStarMatch && filenameStarMatch[1]) {
                        fileName = decodeURIComponent(filenameStarMatch[1]);
                    } else {
                        const filenameMatch = disposition.match(/filename="?([^\";]+)"?/);
                        if (filenameMatch && filenameMatch[1]) {
                            fileName = filenameMatch[1];
                        }
                    }
                }
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
            else {
                showToast('error', 'Failed to generate excel');
            }
        } catch (error) {
            showToast('error', 'Failed to generate excel');
        } finally {
            setIsLoading(false);
        }
    };

    const getDashboardLogList = async () => {
        setIsLoading(true);
        try {
            let resolvedDateRange = "";

            if (dateRange && dateRange.toString().indexOf("Between") > -1) {
                resolvedDateRange = fromDateRef.current + "|" + toDateRef.current;
            } else if (dateRange) {
                resolvedDateRange = dateRange;
            }


            const dashboardLogSearchParam = {
                dateRange: resolvedDateRange,
                dashboard: (dashboard == null || dashboard == "") ? "" : dashboard,
                name: (userName == null || userName == "") ? "" : userName,
                dashboardGroupID: (DashboardGroupID == "" || DashboardGroupID == 'select' || DashboardGroupID == null) ? null : DashboardGroupID
            };
            const response = await axiosPost(GetDashboardLogListSearchUrl, dashboardLogSearchParam);
            if (response) {
                setdashboardLogList(response);
                setFilteredDashboardLog(response);
            } else {
                showToast('error', 'Failed to fetch dashboard log: No data found.');
                console.error("Failed to fetch dashboard log: No data found.");
            }
        } catch (error) {
            console.error("Error fetching dashboard log:", error);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        const userInfo = localStorage.getItem("userInfo");
        if (userInfo == null) {
            navigate("/login/KeyStone_Login");
            return;
        } else {
            getDashboardLogList();
            if (groupFillList.data) setDashboardGroupFillList(groupFillList.data);
        }
    }, [reset, groupFillList.data]);

    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [dateRange, setDateRange] = useState("");

    const fromDateRef = useRef("");
    const toDateRef = useRef("");

    const handleFromDateChange = useCallback(
        _.debounce((event) => {
            if (event != "" && event != null && event != undefined) {
                const formattedfromDate = moment(event, "YYYY-MM-DD HH:mm:ss").format("DD-MMM-YYYY");
                setFromDate(event);
                fromDateRef.current = formattedfromDate;
                console.log("fromDate:", fromDate);
                handleDateChange();
            }
        }, 300), []);

    const handleToDateChange = useCallback(
        _.debounce((event) => {
            if (event != "" && event != null && event != undefined) {
                const formattedtoDate = moment(event, "YYYY-MM-DD HH:mm:ss").format("DD-MMM-YYYY");
                setToDate(event);
                toDateRef.current = formattedtoDate;
                handleDateChange();
            }
        }, 300), []);


    const isFromDateInvalid = !fromDateRef.current;
    const isToDateInvalid = !toDateRef.current;

    const handleDateChange = (_event) => {
        if (fromDateRef.current &&
            (!toDateRef.current)) {
            setDateRange("greater than " + fromDateRef.current);
        }
        else if (toDateRef.current &&
            (!fromDateRef.current)) {
            setDateRange("less than " + toDateRef.current);
        }
        else if (fromDateRef.current && toDateRef.current) {
            setDateRange("Between " + fromDateRef.current + " and " + toDateRef.current);
        }
        else if (isFromDateInvalid || isToDateInvalid) {
            setDateRange("");
        }
    }
    
    const [showDatePickers, setShowDatePickers] = useState(false);
    const openDatePickers = () => {
        setShowDatePickers(true);
    };
    return (
        <>
            {isLoading ? <Loader /> : <></>}
            <HeaderBlock left="" title={t('dashboard_log.dashboardLog')} leftCenterAlign="true" actionsCenterAlign="true" />

            <Box
                id="main" className="full-width padding-right-m padding-left-m padding-bottom-m padding-top-none logMain">
                <Box className="pagetitle main-area-top"
                    textAlign="center">
                    <section className="section page-body">
                        <Box className="margin-top-m margin-bottom-none"
                            sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 2,
                                alignItems: "flex-start",
                            }}
                        >
                            <Box className="text-align-left logWidth">
                                <TextField className="padding-top-s margin-bottom-s full-width" label='Date Range'
                                    value={dateRange}
                                    InputProps={{
                                        readOnly: true,
                                    }} variant="outlined"
                                    onClick={openDatePickers}
                                    placeholder="Select Date"
                                />
                                {showDatePickers && (
                                    <Box className="full-width">
                                        <TextField className="margin-bottom-xs"
                                            type="date"
                                            value={fromDate}
                                            onChange={(e) => handleFromDateChange(e.target.value)}
                                            required
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        <TextField className="margin-bottom-xs"
                                            type="date"
                                            value={toDate}
                                            onChange={(e) => handleToDateChange(e.target.value)}
                                            required
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Box>
                                )}
                            </Box>
                            {/* Filters */}
                            <TextField className="padding-top-s list-page-control-dashlog margin-bottom-s"
                                label={t('dashboard_log.dashboardGroup')}
                                onChange={(e) => {
                                    setDashboardGroupID(e.target.value)
                                }}
                                value={DashboardGroupID}
                                select
                                required
                                variant="outlined"
                            >
                                <MenuItem value="0">{t('dashboard_log.selectDashboardGroup')}</MenuItem>
                                {DashboardGroupFillList.map((data) => (
                                    <MenuItem key={data.code} value={data.code}>
                                        {data.description}
                                    </MenuItem>
                                ))}
                            </TextField>
                            {/* Dashboard */}
                            <TextField className="padding-top-s list-page-control-dashlog margin-bottom-s"
                                label={t('dashboard_log.dashboard')}
                                placeholder={t('dashboard_log.dashboard')}
                                variant="outlined"
                                value={dashboard}
                                onChange={handleDashboardChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />

                            {/* Buttons */}
                            <Button className="margin-top-s logborder"
                                variant="contained"
                                color="primary"
                                onClick={searchBtnCall}
                            >
                                {t('dashboard_log.view')}
                            </Button>
                            <Button className="margin-top-s logborder"
                                variant="contained"
                                color="primary"
                                onClick={resetSearch}
                            >
                                {t('common.reset')}
                            </Button>
                            <Box className="row ">
                                <Button variant="outlined"
                                    className="margin-top-s logborder"
                                    color="primary"
                                    onClick={() => exportBtnCall()}
                                >
                                    {t('dashboard_log.exportToExcel')}
                                </Button>
                            </Box>
                            <Typography variant="body2" className="logfontsize">
                                {t('dashboard_log.total')} {totalItems} {t('dashboard_log.recordsFound')}
                            </Typography>
                            <TableContainer className="margin-bottom-xl list-height list-height padding-left-base padding-right-base padding-x-base padding-bottom-base padding-top-none shadow-0 border-light border-radius">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>{t('dashboard_log.viewDate')}</TableCell>
                                            <TableCell>{t('dashboard_log.user')}</TableCell>
                                            <TableCell>{t('dashboard_log.userType')}</TableCell>
                                            <TableCell>{t('dashboard_log.dashboard')}</TableCell>
                                            <TableCell>{t('dashboard_log.group')}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {paginatedDashboardLog?.length > 0 ? (
                                            paginatedDashboardLog?.map((dashboardLog, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{moment(dashboardLog.viewDate, "DD-MM-YYYY HH:mm:ss").isValid()
                                                        ? moment(dashboardLog.viewDate, "DD-MM-YYYY HH:mm:ss").format("DD MMM YYYY HH:mm:ss")
                                                        : "Invalid Date"}</TableCell>
                                                    <TableCell>{dashboardLog.user}</TableCell>
                                                    <TableCell>{dashboardLog.userType}</TableCell>
                                                    <TableCell sx={{ width: '20rem', wordWrap: "break-word", whiteSpace: "normal", wordBreak: "break-word" }}>{dashboardLog.dashboard}</TableCell>
                                                    <TableCell sx={{ width: '20rem', wordWrap: "break-word", whiteSpace: "normal", wordBreak: "break-word" }}>{dashboardLog.dashboardGroup}</TableCell>
                                                </TableRow>
                                            ))) : (
                                            <TableCell colSpan={6}>{t('common.noRecordsFound')}</TableCell>
                                        )}
                                    </TableBody>
                                </Table>
                                <CommonPagination
                                    totalItems={totalItems}
                                    currentPage={currentPage}
                                    onPageChange={setCurrentPage}
                                />
                            </TableContainer>

                        </Box> </section>
                </Box>
            </Box>

            {ToastComponent}
        </>
    );
}

export default withTranslation()(DashboardLog);
